module.exports = __webpack_public_path__ + "static/should-we-eat-meat-3dfd32fe52a3ec798c50ea48747c33f3.jpg";